import { useState } from 'react';
import { BOTS } from '../data/content';
import './BotCatalog.css';

const COLOR_MAP = {
  teal:   { icon:'rgba(29,217,197,0.1)',  iconBorder:'rgba(29,217,197,0.2)',  tag:'teal' },
  blue:   { icon:'rgba(26,111,212,0.1)',  iconBorder:'rgba(26,111,212,0.2)',  tag:'blue' },
  purple: { icon:'rgba(139,92,246,0.1)',  iconBorder:'rgba(139,92,246,0.2)',  tag:'purple' },
  amber:  { icon:'rgba(245,158,11,0.1)',  iconBorder:'rgba(245,158,11,0.2)',  tag:'amber' },
  green:  { icon:'rgba(34,197,94,0.1)',   iconBorder:'rgba(34,197,94,0.2)',   tag:'green' },
  red:    { icon:'rgba(239,68,68,0.1)',   iconBorder:'rgba(239,68,68,0.2)',   tag:'red' },
};

export default function BotCatalog() {
  const [active, setActive] = useState(null);

  return (
    <section id="bots" className="section-divider">
      <div className="section-wrap">
        <span className="eyebrow">Bot Catalog</span>
        <h2 className="sec-title">Every bot your business needs.</h2>
        <p className="sec-sub">
          Eight domain-specific AI agents — each trained on its domain,
          integrated with your systems, and ready to deploy in weeks.
        </p>

        <div className="bots__grid">
          {BOTS.map(bot => {
            const c = COLOR_MAP[bot.color];
            const isOpen = active === bot.id;
            return (
              <div
                key={bot.id}
                className={`bot-card ${isOpen ? 'bot-card--open' : ''}`}
                style={{ '--accent-icon': c.icon, '--accent-border': c.iconBorder }}
              >
                <div className="bot-card__top">
                  <div className="bot-card__icon" style={{ background:c.icon, border:`1px solid ${c.iconBorder}` }}>
                    {bot.emoji}
                  </div>
                  <div className="bot-card__head">
                    <h3 className="bot-card__name">{bot.name}</h3>
                    <p className="bot-card__tagline">{bot.tagline}</p>
                  </div>
                  <button
                    className="bot-card__toggle"
                    onClick={() => setActive(isOpen ? null : bot.id)}
                    aria-label="Expand"
                  >
                    {isOpen ? '−' : '+'}
                  </button>
                </div>

                <p className="bot-card__desc">{bot.desc}</p>

                <div className="tags">
                  {bot.tags.map(t => <span key={t} className={`tag ${c.tag}`}>{t}</span>)}
                </div>

                {isOpen && (
                  <div className="bot-card__detail">
                    <div className="bot-detail-cols">
                      <div>
                        <p className="bot-detail-label">Capabilities</p>
                        <ul className="bot-detail-list">
                          {bot.capabilities.map(cap => <li key={cap}>{cap}</li>)}
                        </ul>
                      </div>
                      <div>
                        <p className="bot-detail-label">Business outcomes</p>
                        <ul className="bot-detail-list bot-detail-list--outcomes">
                          {bot.outcomes.map(o => <li key={o}>{o}</li>)}
                        </ul>
                      </div>
                    </div>
                    <a href="#contact" className="btn-primary bot-card__cta">
                      Get this bot →
                    </a>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
